import { render } from "./GradientButton.vue?vue&type=template&id=0a555b9f&scoped=true"
const script = {}

import "./GradientButton.vue?vue&type=style&index=0&id=0a555b9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a555b9f"]])

export default __exports__